import React, { useState } from 'react';
import './_Toggle.scss';

export const ToggleSwitch = ({
  optionA, optionB, onChange, value,
}) => {
  const [inverted, setInverted] = useState(value === optionB);

  const handleChange = () => {
    setInverted(!inverted);
    onChange(value === optionA ? optionB : optionA);
  };

  return (
    <div onClick={handleChange} className={`toggle ${inverted && 'toggle--inverted'}`}>
      <span className={`toggle__option ${inverted && 'toggle__option--inverted'}`}>{optionA}</span>
      <span className={`toggle__option ${!inverted && 'toggle__option--inverted'}`}>{optionB}</span>
    </div>
  );
};